webpackJsonp([18089617347968],{

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(24);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(502);
	
	var _organizacja = __webpack_require__(648);
	
	var _organizacja2 = _interopRequireDefault(_organizacja);
	
	var _tech = __webpack_require__(650);
	
	var _tech2 = _interopRequireDefault(_tech);
	
	var _sztukaBg = __webpack_require__(649);
	
	var _sztukaBg2 = _interopRequireDefault(_sztukaBg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var offersList = [{
	  label: 'Sztuka i rozrywka',
	  to: '/sztuka-i-rozrywka',
	  image: _sztukaBg2.default
	}, {
	  label: 'Technika Estradowa',
	  to: '/technika-estradowa',
	  image: _tech2.default
	}, {
	  label: 'Organizacja wydarzeń',
	  to: '/organizacja-wydarzen',
	  image: _organizacja2.default
	}];
	
	var SingleOffer = function SingleOffer(_ref) {
	  var offer = _ref.offer;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'single-offer', style: { backgroundImage: 'url(' + offer.image + ')' } },
	    _react2.default.createElement(
	      'p',
	      { className: 'single-offer__label' },
	      offer.label
	    )
	  );
	};
	
	var Offers = function Offers() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'offers-section' },
	    _react2.default.createElement(
	      'ul',
	      { className: 'offers-section__list' },
	      offersList.map(function (offer) {
	        return _react2.default.createElement(
	          'li',
	          { className: 'offers-section__element', key: offer.label },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: 'offers-section__link', to: offer.to },
	            _react2.default.createElement(SingleOffer, { offer: offer })
	          )
	        );
	      })
	    )
	  );
	};
	
	exports.default = Offers;
	module.exports = exports['default'];

/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Section = __webpack_require__(48);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Offers = __webpack_require__(262);
	
	var _Offers2 = _interopRequireDefault(_Offers);
	
	var _mainBg = __webpack_require__(647);
	
	var _mainBg2 = _interopRequireDefault(_mainBg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var text = '\n  <p><strong>CustomArt</strong>\xA0to 12 lat do\u015Bwiadczenia scenicznego, ogromna sie\u0107 kontakt\xF3w, doskona\u0142a znajomo\u015B\u0107 potrzeb zar\xF3wno agencji, klient\xF3w bezpo\u015Brednich jak i samych artyst\xF3w oraz rozbudowana oferta us\u0142ug dedykowanych dla bran\u017Cy eventowej.</p>';
	
	var OfferSection = function OfferSection() {
	  return _react2.default.createElement(
	    _Section2.default,
	    {
	      title: 'Oferta',
	      background: _mainBg2.default,
	      isFirstSection: true,
	      subtitle: text
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'section__container' },
	      _react2.default.createElement(_Offers2.default, null)
	    )
	  );
	};
	
	exports.default = OfferSection;
	module.exports = exports['default'];

/***/ }),

/***/ 647:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/main-bg.d3efaee2.jpg";

/***/ }),

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/organizacja.678e8550.jpg";

/***/ }),

/***/ 502:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 649:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sztuka-bg.87140b5c.jpg";

/***/ }),

/***/ 650:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tech.089a94d9.jpg";

/***/ }),

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Helmet = __webpack_require__(26);
	
	var _Helmet2 = _interopRequireDefault(_Helmet);
	
	var _OfferSection = __webpack_require__(263);
	
	var _OfferSection2 = _interopRequireDefault(_OfferSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var seo = 'CustomArt to 12 lat doświadczenia scenicznego, ogromna sieć kontaktów, doskonała znajomość potrzeb zarówno agencji, klientów bezpośrednich jak i samych artystów oraz rozbudowana oferta usług dodatkowych.';
	
	var Offer = function Offer() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _Helmet2.default,
	      { title: 'Oferta' },
	      _react2.default.createElement('meta', { name: 'description', content: seo })
	    ),
	    _react2.default.createElement(_OfferSection2.default, null),
	    _react2.default.createElement('div', { style: { paddingTop: 100 } })
	  );
	};
	
	exports.default = Offer;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-oferta-js-edd5e8fbc7c1b6e96292.js